import {fetchPost} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const sell = (
    venueId,
    userCode,
    adminCode,
    virtualTipz,
    sellType,
    code,
    id,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    const params = {
        userCode: userCode,
        adminCode: adminCode,
        virtualTipz: virtualTipz,
        sellType: sellType,
        code: code,
        id: id
    };
    fetchPost(
        uri + "/venue/" + venueId + "/sell",
        successMethod,
        errorMethod,
        params,
        getAccessTokenSilently);
};

export const addDancerAppToVenue = (
    venueId,
    dancerCode,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    const params = {
        dancerCode: dancerCode
    };
    fetchPost(
        uri + "/venue/" + venueId + "/dancerapp/add",
        successMethod,
        errorMethod,
        params,
        getAccessTokenSilently);
};

export const createDancerAppForVenue = (
    venueId,
    name,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    const params = {
        name: name
    };
    fetchPost(
        uri + "/venue/" + venueId + "/dancerapp/create",
        successMethod,
        errorMethod,
        params,
        getAccessTokenSilently);
};

export const giveVT = (
    venueId,
    userCode,
    adminCode,
    packageId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    const params = {
        userCode: userCode,
        adminCode: adminCode,
        packageId: packageId
    };
    fetchPost(
        uri + "/venue/" + venueId + "/vt",
        successMethod,
        errorMethod,
        params,
        getAccessTokenSilently);
};

export const revertVT = (
    venueId,
    userCode,
    adminCode,
    revertAmount,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    const params = {
        userCode: userCode,
        adminCode: adminCode,
        revertAmount: revertAmount
    };
    fetchPost(
        uri + "/venue/" + venueId + "/vt/revert",
        successMethod,
        errorMethod,
        params,
        getAccessTokenSilently);
};
